module.exports = __webpack_public_path__ + "images/views/ViewsCardBackBannerImage.99b9285cb72ff35e4f49.svg";